import React from 'react';
import { Skeleton } from 'antd';

const styles = {
  hrStyle: {
    opacity: '0.2',
    backgroundColor: '#696a6b',
    height: '1px',
    width: '96%',
    margin: '17px 24px 0 24px',
  },
  wrapper: {
    width: '96%',
    margin: '0 0 0 25px',
    backgroundColor: '#fff',
  },
};

const renderSkeletonList = () => new Array(6).fill().map((_, i) => (
  <span style={{ width: '100%' }} key={`${i}${Date.now()}`}>
    <Skeleton title={false} rows={2} loading active />
    <hr style={styles.hrStyle} />
  </span>
));

export const withTableSkeleton = (Table) => (props) => (props?.isLoading ? <div style={styles.wrapper}>{renderSkeletonList()}</div> : <Table {...props} />);
